import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PartnersModule } from '@app/modules/partners/partners.module';
import { SignupTrialComponent } from '@app/modules/user/signup/signup-trial/signup-trial.component';
import { SharedModule } from '../../../shared/shared.module';
import { ConversationSimulatorComponent } from './conversation-simulator/conversation-simulator.component';
import { SignupAboutComponent } from './signup-about/signup-about.component';
import { SignupChannelsComponent } from './signup-channels/signup-channels.component';
import { SignupContinueComponent } from './signup-continue/signup-continue.component';
import { SignupDoneComponent } from './signup-done/signup-done.component';
import { SignupHeaderComponent } from './signup-header/signup-header.component';
import { SignupMenuComponent } from './signup-menu/signup-menu.component';
import { ScheduleMeetingDialogComponent } from './signup-messaging-rules/schedule-meeting-dialog/schedule-meeting-dialog.component';
import { SignupMessagingRulesComponent } from './signup-messaging-rules/signup-messaging-rules.component';
import { SignupPasswordComponent } from './signup-password/signup-password.component';
import { SignupPropertiesComponent } from './signup-properties/signup-properties.component';
import { SignupReviewListingsComponent } from './signup-review-listings/signup-review-listings.component';
import { SignupRoutingModule } from './signup-routing.module';
import { SignupStartComponent } from './signup-start/signup-start.component';
import { SignupStatusComponent } from './signup-status/signup-status.component';
import { SignupValidatePhoneComponent } from './signup-validate-phone/signup-validate-phone.component';
import { SignupWelcomeComponent } from './signup-welcome/signup-welcome.component';
import { SignupWithAirbnbComponent } from './signup-with-airbnb/signup-with-airbnb.component';

@NgModule({
  declarations: [
    SignupAboutComponent,
    SignupValidatePhoneComponent,
    SignupWelcomeComponent,
    SignupWithAirbnbComponent,
    SignupStatusComponent,
    SignupHeaderComponent,
    SignupStartComponent,
    SignupPropertiesComponent,
    SignupChannelsComponent,
    SignupPasswordComponent,
    SignupMenuComponent,
    SignupReviewListingsComponent,
    SignupDoneComponent,
    SignupContinueComponent,
    SignupMessagingRulesComponent,
    ConversationSimulatorComponent,
    ScheduleMeetingDialogComponent,
    SignupTrialComponent,
  ],
  imports: [CommonModule, SharedModule, SignupRoutingModule, PartnersModule],
})
export class SignupModule {}
